<div class="clocking-bg">

	<img src="../../../../assets/Logo.png" width="200" style="margin-top:25px; margin-left:140px; margin-bottom:25px;">
	<input class="input-override" type="password" name="password" (keyup.enter)="submitData()" [(ngModel)]="fobScannedEntity.fobId" placeholder="Fob ID"
		autocomplete="off"
		style="margin-left:25px; margin-right:25px;">
		<button class="btn-override" (click)="submitData()" style="margin-left:25px; margin-top:25px;" >
			Submit Details
		</button>
</div>